import { Component, Inject, OnInit } from '@angular/core';
import { LocationOptions } from '../../shared/location-picker/location-picker.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { MainService } from '../../services/optimizer-service/optimizer.service';
import { VendorService } from '../../vendor-portal/vendor.service';

@Component({
  selector: 'app-saved-address',
  templateUrl: './saved-address.component.html',
  styleUrls: ['./saved-address.component.css']
})
export class SavedAddressComponent implements OnInit {

  options: LocationOptions = {
    multipleLocations: false,
    searchBoxText:'Enter Customer Address....'
  };
  locationInfo;
  customer;
  constructor(public dialogRef: MatDialogRef<SavedAddressComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private vendor: VendorService) {
      this.customer = data;
    }

  ngOnInit() {
  }


  locationSelected(locationData) {
    this.locationInfo = locationData[0];
  }

  close(){
    this.dialogRef.close();
  }

  save(){
    if(this.locationInfo){
      this.locationInfo.id = this.customer.savedid;
      this.vendor.saveAddress(this.locationInfo).then(() =>{
        this.dialogRef.close(true);
      }).catch(e =>{
        this.dialogRef.close(false);
      })
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/admin-dashboard/saved-address/saved-address.component.ts